import { z } from "zod";

const AgentResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        name: z.string(),
        color: z.string().regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, "Invalid color format"),
        email: z.string().email().nullable(),
        phone: z.string().nullable(),
        website: z.string().url().nullable(),
        property_id: z.string().uuid(),
        id: z.string().uuid(),
        updated_at: z.string().datetime(),
        created_at: z.string().datetime(),
    }),
});

export { AgentResponseSchema };
export type AgentResponse = z.infer<typeof AgentResponseSchema>;